module.exports = "../../app/cells/pages/guides/v2_featured_cell.rb";